import { LoadAswMasterInfo } from '@lib/interfaces';
import { I18N_CONFIG } from './i18n.config';

// FIXME: 各APPごとに必要に応じて指定する

/** 汎用データマスタキャッシュJSONデータのStoreに保存する際の共通キー */
const LISTDATA_COMMON_STORE_KEY = 'listData_pd_' as const;

/**
 * マスタキャッシュJSONデータのStoreに保存する際のキー
 */
export const MasterStoreKey = {
  /** プロパティマスタ_全リスト */
  PROPERTY: 'property',
  /** DxAPIエラーコード対応マスタ_全リスト */
  DXAPI_ERROR_CODE: 'dxapiErrorCode',
  /** iFlyエラーコード対応マスタ_エラーメッセージ */
  IFLY_ERROR_CODE_ERRORMESSAGE: 'IflyErrorCode_ErrorMessage',
  /** 運用確認メッセージ_全リスト */
  OPERATION_CONFIRM_LOG: 'operationConfirmLog',
  /** Tealium連携用画面名 */
  LISTDATA_PD_001: `${LISTDATA_COMMON_STORE_KEY}001`,
  /** 曜日リスト */
  LISTDATA_PD_016: `${LISTDATA_COMMON_STORE_KEY}016`,
  /** 曜日リスト */
  LISTDATA_PD_016_WEEK_FORMAT: `${LISTDATA_COMMON_STORE_KEY}016_week_format`,
  /** 月リスト */
  LISTDATA_PD_017: `${LISTDATA_COMMON_STORE_KEY}017`,
  CURRENCY_FORMAT_ALL: 'Currency_Format_All',
  OFFICE_ALL: 'Office_All',
  HOLIDAY_NATIONALHOLIDAYLISTFROMTODAY: `Holiday_NationalHolidayListFromToday`,
  DEPARTUREAIRPORT_ALL: 'DepartureAirport_All',
  DESTINATIONAIRPORT_ALL: 'DestinationAirport_All',
  REGION_ALL: 'Region_All',
  LANGCODECONVERT_ALL: 'LangCodeConvert_All',
  /** 空港別時差_空港コード */
  AIRPORT_TIMEDIFF: 'AirportTimeDiff_ByAirportCode',
} as const;

/**
 * ロードするマスタキャッシュ一覧
 */
export const LOAD_MASTER_LIST: LoadAswMasterInfo[] = [
  {
    key: MasterStoreKey.PROPERTY,
    fileName: 'Property_ForAkamaiCache',
  },
  {
    key: MasterStoreKey.DXAPI_ERROR_CODE,
    fileName: 'DxapiErrorCode_ForAkamaiCache',
  },
  {
    key: MasterStoreKey.OPERATION_CONFIRM_LOG,
    fileName: 'OperationConfirmLog',
  },
  {
    key: MasterStoreKey.LISTDATA_PD_016,
    fileName: 'ListLabelValue_pd_016',
  },
  {
    key: MasterStoreKey.LISTDATA_PD_016_WEEK_FORMAT,
    fileName: 'm_list_data_pd_016/M_list_data_pd_016',
    isCurrentLang: true,
  },
  {
    key: MasterStoreKey.LISTDATA_PD_017,
    fileName: 'ListLabelValue_pd_017',
  },
  {
    key: MasterStoreKey.CURRENCY_FORMAT_ALL,
    fileName: 'Currency_Format_All/Currency_Format',
    isCurrentLang: true,
  },
  {
    key: MasterStoreKey.OFFICE_ALL,
    fileName: 'Office_All',
  },
  {
    key: MasterStoreKey.HOLIDAY_NATIONALHOLIDAYLISTFROMTODAY,
    fileName: 'Holiday_NationalHolidayListFromToday',
  },
  {
    key: MasterStoreKey.DEPARTUREAIRPORT_ALL,
    fileName: 'DepartureAirport_All',
    isCurrentLang: true,
  },
  {
    key: MasterStoreKey.DESTINATIONAIRPORT_ALL,
    fileName: 'DestinationAirport_All',
    isCurrentLang: true,
  },
  {
    key: MasterStoreKey.REGION_ALL,
    fileName: 'Region_All',
    isCurrentLang: true,
  },
  {
    key: MasterStoreKey.LANGCODECONVERT_ALL,
    fileName: 'LangCodeConvert_All',
  },
  {
    key: MasterStoreKey.AIRPORT_TIMEDIFF,
    fileName: 'AirportTimeDiff_ByAirportCode',
    suffixKeys: ['_1', '_2'],
  },
  {
    key: MasterStoreKey.IFLY_ERROR_CODE_ERRORMESSAGE,
    fileName: 'IflyErrorCode_ErrorMessage',
  },
];

/**
 * マスタキャッシュJSONデータの各JSONキーPrefix
 */
export const MasterJsonKeyPrefix = {
  /** 静的文言 */
  STATIC: 'm_static_message-',
  /** エラー／ワーニング文言 */
  ERROR: 'm_error_message-',
  /** 動的文言 */
  DYNAMIC: 'm_dynamic_message-',
} as const;
